import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'
import { AiGenerationLoadingContent } from 'components/AIGenerationLoadingContent'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px 16px;
`

export const ImageWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;
`

export const Content = styled.div`
  ${customizeVerticalScrollbarThumbMixin()}
  overflow: auto;
  flex: 1;
  padding: 0 16px 16px;
`

export const ActionsList = styled.div`
  border-top: 1px solid ${COLORS.borderColor};
  padding-top: 24px;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const AiGenerationLoading = styled(AiGenerationLoadingContent)`
  margin: 20px 0;
  padding: 0 20px;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    margin: 12px 0;
  }
`
